import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export const defaultResourceData = [
  {
    id: 1,
    category: "Blog",
    title:
      "Why Digital Twins in Healthcare Are the Next Big Leap in Medical Science",
    description: ".............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2026/01/06/why-digital-twins-in-healthcare-are-the-next-big-leap-in-medical-science/",
    image: (
      <StaticImage
        src="../../images/resource/banner-1.png"
        alt="Digital Twins in Healthcare"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 2,
    category: "Blog",
    title:
      "Digital Twin for Healthcare: How IND TwinHealth is Transforming Personalized Patient Care",
    description: "............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2026/01/05/digital-twin-for-healthcare-how-ind-twinhealth-is-transforming-personalized-patient-care/",
    image: (
      <StaticImage
        src="../../images/resource/blog-2.png"
        alt="TwinHealth Transformation"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 3,
    category: "Blog",
    title:
      "Digital Twin in Healthcare: Applications, Advantages and Case Studies",
    description: "............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2026/01/09/digital-twin-in-healthcare-applications-advantages-and-case-studies/",
    image: (
      <StaticImage
        src="../../images/resource/blog-3.png"
        alt="Digital Twin Applications"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 4,
    category: "Blog",
    title:
      "The Digital Twin’s Digital Transformation of Preventative Healthcare at Twin Health Chennai",
    description: "............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2026/01/08/the-digital-twins-digital-transformation-of-preventative-healthcare-at-twin-health-chennai/",
    image: (
      <StaticImage
        src="../../images/resource/blog-4.png"
        alt="Preventative Healthcare"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 5,
    category: "Blog",
    title: "Twin Health Program Cost: What Affects Value and Benefit",
    description: "............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2026/01/07/twin-health-program-cost-what-affects-what-you-are-valued-and-benefit/",
    image: (
      <StaticImage
        src="../../images/resource/blog-5.png"
        alt="Twin Health Cost"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 6,
    category: "Blog",
    title: "How Digital Twins Are Reimagining the Future of Modern Healthcare",
    description: "............",
    ctaText: "Read More",
    ctaLink:
      "https://indtwinhealth.wordpress.com/2025/12/29/how-digital-twins-are-reimagining-the-future-of-modern-healthcare/",
    image: (
      <StaticImage
        src="../../images/resource/blog-6.png"
        alt="Future of Healthcare"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Blog"],
  },
  {
    id: 7,
    category: "Media Coverage",
    title:
      "Twin Health isn't Just Treating Diabetes. It's Digitally Re-coding Metabolism",
    description: "Prodwrks",
    ctaText: "Read More",
    ctaLink:
      "https://prodwrks.com/twin-health-isnt-treating-diabetes-its-digitally-re-coding-metabolism/",
    image: (
      <StaticImage
        src="../../images/resource/media-1.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Media Coverage"],
  },
  {
    id: 8,
    category: "Media Coverage",
    title: "ICAT partners with Twin Health to revolutionize healthcare and...",
    description: "Ehealth",
    ctaText: "Read More",
    ctaLink:
      "https://ehealth.eletsonline.com/2024/04/icat-partners-with-twin-health-to-revolutionize-healthcare-and-employee-wellbeing/",
    image: (
      <StaticImage
        src="../../images/resource/media-2.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Media Coverage"],
  },
  {
    id: 9,
    category: "Media Coverage",
    title: "Now, diabetes reversal with digital twin, AI",
    description: "Health Care Radius",
    ctaText: "Read More",
    ctaLink:
      "https://www.healthcareradius.in/features/digital-healthcare/now-diabetes-reversal-with-digital-twin-ai",
    image: (
      <StaticImage
        src="../../images/resource/media-3.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Media Coverage"],
  },
  {
    id: 10,
    category: "Media Coverage",
    title:
      "IIT start-up creates digital twin to monitor health; study shows success in...",
    description: "The Hindu",
    ctaText: "Read More",
    ctaLink:
      "https://www.thehindu.com/news/national/tamil-nadu/iit-start-up-creates-digital-twin-to-monitor-health-study-shows-success-in-controlling-blood-sugar-levels/article67587753.ece",
    image: (
      <StaticImage
        src="../../images/resource/media-4.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Media Coverage"],
  },
  {
    id: 11,
    category: "Media Coverage",
    title:
      "Twin Health raises Rs 1,000 crore to scale Whole Body Digital Twin technology...",
    description: "The Economic Times",
    ctaText: "Read More",
    ctaLink:
      "https://m.economictimes.com/tech/funding/twin-health-raises-rs-1000-crore-to-scale-its-whole-body-digital-twin-technology/articleshow/86833089.cms",
    image: (
      <StaticImage
        src="../../images/resource/media-5.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Media Coverage"],
  },
  {
    id: 12,
    category: "Press Releases",
    title:
      "Twin Health announces new initiative #PledgeToReverse on World Diabetes Day",
    description: "(ANI)",
    ctaText: "Read More",
    ctaLink:
      "https://www.business-standard.com/content/press-releases-ani/twin-health-announces-new-initiative-pledgetoreverse-on-world-diabetes-day-121111500477_1.html",
    image: (
      <StaticImage
        src="../../images/resource/press-1.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Press Releases"],
  },
  {
    id: 13,
    category: "Press Releases",
    title:
      "Twin Health announces new initiative #PledgeToReverse on World Diabetes Day",
    description: "(ANI mirror)",
    ctaText: "Read More",
    ctaLink:
      "https://theprint.in/ani-press-releases/twin-health-announces-new-initiative-pledgetoreverse-on-world-diabetes-day/766286/",
    image: (
      <StaticImage
        src="../../images/resource/press-2.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Press Releases"],
  },
  {
    id: 14,
    category: "Press Releases",
    title:
      "Twin Health announces new initiative #PledgeToReverse on World Diabetes Day",
    description: "(Healthcare Radius mirror)",
    ctaText: "Read More",
    ctaLink:
      "https://www.healthcareradius.in/uncategorized/31599-twin-health-announces-new-initiative-pledgetoreverse-on-world-diabetes-day",
    image: (
      <StaticImage
        src="../../images/resource/press-3.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Press Releases"],
  },
  {
    id: 15,
    category: "Whitepapers",
    title:
      "Artificial Intelligence Offers Significant Rate of Remission for Type 2 Diabetes Compared to Standard Care",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://diabetes.org/newsroom/artificial-intelligence-offers-significant-rate-remission-type-2-diabetes-compared-to-standard-care",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-3.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 16,
    category: "Whitepapers",
    title:
      "Type 2 Diabetes Pharmacotherapy De-Escalation Through AI-EnabledLifestyle Modications: A Randomized Clinical Trial",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://catalyst.nejm.org/doi/full/10.1056/CAT.25.0016",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-13.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 17,
    category: "Podcasts",
    title:
      "Master Your Nutrition & Lifestyle: Prevent and Overcome Metabolic Disorders -",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://youtube.com/watch?v=829tOnWy5h0",
    image: (
      <StaticImage
        src="../../images/resource/podcast-1.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Podcasts"],
  },
  {
    id: 18,
    category: "Podcasts",
    title:
      "Unlocking The Secrets To Reverse Chronic Metabolic Diseases (Yes! It's Possible)-",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://youtube.com/watch?v=5J-MiritxXU",
    image: (
      <StaticImage
        src="../../images/resource/podcast-2.png"
        alt="Clinical Research"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Podcasts"],
  },
  {
    id: 19,
    category: "Publications",
    title:
      "Type 2 Diabetes Remission: A Systematic Review and Meta-analysis...",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://diabetesjournals.org/care/article/48/12/2181/163414/Type-2-Diabetes-Remission-A-Systematic-Review-and",
    image: (
      <StaticImage
        src="../../images/resource/publication-1.png"
        alt="Type 2 Diabetes Remission"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 20,
    category: "Publications",
    title:
      "Personalized Nutrition in Type 2 Diabetes Remission: Application of Digital Twin...",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://www.frontiersin.org/journals/endocrinology/articles/10.3389/fendo.2024.1485464/full",
    image: (
      <StaticImage
        src="../../images/resource/publication-2.png"
        alt="Personalized Nutrition in Type 2 Diabetes Remission"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 21,
    category: "Publications",
    title:
      "One-year outcomes of a digital twin intervention for type 2 diabetes: a retrospective real-world study",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://www.nature.com/articles/s41598-024-76584-7",
    image: (
      <StaticImage
        src="../../images/resource/publication-3.png"
        alt="One-year outcomes of a digital twin intervention for type 2 diabetes"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 22,
    category: "Publications",
    title:
      "Digital Twin-Enabled Personalized Nutrition Improves Metabolic Dysfunction-Associated Fatty Liver Disease in Type 2 Diabetes: Results of a 1-Year Randomized Controlled Study",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://www.endocrinepractice.org/article/S1530-891X(23)00543-8/fulltext",
    image: (
      <StaticImage
        src="../../images/resource/publication-4.png"
        alt="Digital Twin-Enabled Personalized Nutrition Improves Metabolic Dysfunction"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 23,
    category: "Publications",
    title:
      "Digital Twin in Managing Hypertension Among People With Type 2 Diabetes: 1-Year Randomized Controlled Trial",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://www.jacc.org/doi/10.1016/j.jacadv.2024.101172",
    image: (
      <StaticImage
        src="../../images/resource/publication-5.png"
        alt="Digital Twin in Managing Hypertension Among People With"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 24,
    category: "Publications",
    title:
      "Digital Twin Technology in Resolving Polycystic Ovary Syndrome and Improving Metabolic Health: A Comprehensive Case Study",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://www.endocrinologydiabetes.org/article/S2376-0605(24)00131-7/fulltext",
    image: (
      <StaticImage
        src="../../images/resource/publication-6.png"
        alt="Digital Twin Technology in Resolving Polycystic Ovary Syndrome"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 25,
    category: "Publications",
    title:
      "Digital Twin Technology for Management of Chronic Metabolic Disease. InLifestyle Medicine: Closing Research, Practice, and Knowledge Gaps 2025 Apr 25 (pp. 651-670)",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://link.springer.com/chapter/10.1007/978-3-031-82888-1_32",
    image: (
      <StaticImage
        src="../../images/resource/publication-7.png"
        alt="Digital Twin Technology for Management of Chronic Metabolic"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 26,
    category: "Publications",
    title:
      "The future of precision diabetes: Digital twin. Implementation of Personalized...",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://www.sciencedirect.com/science/chapter/edited-volume/abs/pii/B9780323988087000217",
    image: (
      <StaticImage
        src="../../images/resource/publication-8.png"
        alt="The future of precision diabetes: Digital twin. Implementation of Personalized"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 27,
    category: "Publications",
    title:
      "Correlation Among A1c Improvement, Weight Reduction, and Decreased ASCVD...",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://www.ahajournals.org/doi/10.1161/circ.149.suppl_1.P468",
    image: (
      <StaticImage
        src="../../images/resource/publication-9.png"
        alt="Correlation Among A1c Improvement, Weight Reduction, and Decreased ASCVD"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 28,
    category: "Publications",
    title:
      "Effectiveness Of Digital Twin Technology For The Improvement In Depression Among...",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://academic.oup.com/jes/article/6/Supplement_1/A279/6787442",
    image: (
      <StaticImage
        src="../../images/resource/publication-10.png"
        alt="Effectiveness Of Digital Twin Technology For The Improvement In Depression Among"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 29,
    category: "Publications",
    title:
      "Metabolic Benefits Beyond Glycemic Control with Artificial Intelligence, Internet...",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://diabetesjournals.org/diabetes/article/71/Supplement_1/26-OR/146723/26-OR-Metabolic-Benefits-beyond-Glycemic-Control",
    image: (
      <StaticImage
        src="../../images/resource/publication-11.png"
        alt="Metabolic Benefits Beyond Glycemic Control with Artificial Intelligence, Internet"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 30,
    category: "Publications",
    title:
      "Quantification of Adiposity, Liver and Pancreas Fat with Magnetic Reson...",
    description: ".................",
    ctaText: "Read More",
    ctaLink:
      "https://www.endocrinepractice.org/article/S1530-891X(22)00707-8/abstract",
    image: (
      <StaticImage
        src="../../images/resource/publication-12.png"
        alt="Quantification of Adiposity, Liver and Pancreas Fat with Magnetic Reson"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 31,
    category: "Publications",
    title:
      "Type 2 Diabetes Pharmacotherapy De-Escalation Through AI-Enabled Lifestyle...",
    description: ".................",
    ctaText: "Read More",
    ctaLink: "https://catalyst.nejm.org/doi/full/10.1056/CAT.25.0016",
    image: (
      <StaticImage
        src="../../images/resource/publication-13.png"
        alt="Type 2 Diabetes Pharmacotherapy De-Escalation Through AI-Enabled Lifestyle"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Publications"],
  },
  {
    id: 32,
    category: "Whitepapers",
    title:
      "Type 2 Diabetes Remission: A Systematic Review and Meta-analysis of Nonsurgical Randomized Controlled Trials",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://diabetesjournals.org/care/article/48/12/2181/163414/Type-2-Diabetes-Remission-A-Systematic-Review-and",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-4.png"
        alt="Type 2 Diabetes Remission: A Systematic Review and Meta-analysis of"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 33,
    category: "Whitepapers",
    title:
      "Personalized nutrition in type 2 diabetes remission: application of digital twin technology for predictive glycemic control",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://www.frontiersin.org/journals/endocrinology/articles/10.3389/fendo.2024.1485464/full",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-5.png"
        alt="Personalized nutrition in type 2 diabetes remission: application of digital twin"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 34,
    category: "Whitepapers",
    title:
      "One-year outcomes of a digitaldiabetes: a retrospective real-world study",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://www.nature.com/articles/s41598-024-76584-7",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-6.png"
        alt="One-year outcomes of a digitaldiabetes: a retrospective real-world study"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 35,
    category: "Whitepapers",
    title:
      "Digital Twin-Enabled Personalized Nutrition Improves Metabolic Dysfunction-Associated Fatty Liver Disease in Type 2 Diabetes: Results of a 1-Year Randomized Controlled Study",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://pubmed.ncbi.nlm.nih.gov/37778441/",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-7.png"
        alt="Digital Twin-Enabled Personalized Nutrition Improves Metabolic Dysfunction-..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 36,
    category: "Whitepapers",
    title:
      "Digital Twin in Managing Hypertension Among People With Type 2 Diabetes 1-Year Randomized Controlled Trial",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://www.jacc.org/doi/10.1016/j.jacadv.2024.101172",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-8.png"
        alt="Digital Twin in Managing Hypertension Among People With Type 2..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 37,
    category: "Whitepapers",
    title:
      "Digital Twin Technology in Resolving Polycystic Ovary Syndrome and Improving Metabolic Health: A Comprehensive Case Study",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://pubmed.ncbi.nlm.nih.gov/39896947/",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-9.png"
        alt="Digital Twin Technology in Resolving Polycystic Ovary Syndrome..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 38,
    category: "Whitepapers",
    title:
      "Digital Twin Technology for Management of Chronic Metabolic Disease",
    description: "......................",
    ctaText: "Read More",
    ctaLink: "https://link.springer.com/chapter/10.1007/978-3-031-82888-1_32",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-10.png"
        alt="Digital Twin Technology for Management of Chronic Metabolic..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 39,
    category: "Whitepapers",
    title: "The Future of Precision Diabetes Digital Twin Academic Press",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://www.researchgate.net/publication/387624349_The_future_of_precision_diabetes_Digital_twin",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-11.png"
        alt="The Future of Precision Diabetes Digital Twin Academic Press"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 40,
    category: "Whitepapers",
    title:
      "1811-LB: Improvement in diabetic Retinopathy and Achieveing Remission of Type 2 Diabetes Mellitus through Digital twin Technology- A one year Intervention study",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://diabetesjournals.org/diabetes/article/73/Supplement_1/1811-LB/156448/1811-LB-Improvement-in-Diabetic-Retinopathy-and",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-14.png"
        alt="1811-LB: Improvement in diabetic Retinopathy and Achieveing Remission of..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
  {
    id: 41,
    category: "Whitepapers",
    title:
      "Evaluating the impact of a digital twin intervention on type 2 diabetes remission at 18 months: a cluster specific analysis",
    description: "......................",
    ctaText: "Read More",
    ctaLink:
      "https://www.easd.org/media-centre/#!resources/b-evaluating-the-impact-of-a-digital-twin-intervention-on-type-2-diabetes-remission-at-18-months-a-cluster-specific-analysis-b",
    image: (
      <StaticImage
        src="../../images/resource/whitepaper-12.png"
        alt="Evaluating the impact of a digital twin intervention on type 2 diabetes remission..."
        placeholder="blurred"
        loading="lazy"
      />
    ),
    tags: ["Whitepapers"],
  },
];
